export default __webpack_public_path__ + "static/media/logo.e8819a6c.png";